import mkdirp from './index.js'

export = Object.assign(mkdirp, { default: mkdirp, mkdirp })
